// Section heading icons are regular weight (rather than the usual light) so
// the glyph matches the semibold heading text it sits next to.
import { faHexagonNodes } from '@fortawesome/pro-regular-svg-icons/faHexagonNodes';
import { faArrowProgress } from '@fortawesome/pro-regular-svg-icons/faArrowProgress';
import { faEnvelopeCircleCheck } from '@fortawesome/pro-regular-svg-icons/faEnvelopeCircleCheck';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import {
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';

export const SEMANTIC_CATEGORY: SemanticCategory = 'heading';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  'ai-credits': faHexagonNodes,
  'agentic-workflows': faArrowProgress,
  'marketing-platform': faEnvelopeCircleCheck,
  'custom-objects': faLayerGroup,
};

export const labels: IconLabel = {
  'ai-credits': {
    title: (t) => '',
    description: (t) => t('Kizen AI Credits'),
  },
  'agentic-workflows': {
    title: (t) => '',
    description: (t) => t('Agentic Workflows'),
  },
  'marketing-platform': {
    title: (t) => '',
    description: (t) => t('Marketing Platform'),
  },
  'custom-objects': {
    title: (t) => '',
    description: (t) => t('Custom Objects'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {};

export const animation: IconAnimation = {};
